import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import HelpGenieLogo from '@/components/ui/HelpGenieLogo';
import { Button } from '@/components/ui/button';

export default function ConsumerNav() {
  const { user, userProfile, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-30 w-full bg-transparent">
      <div className="w-full max-w-screen-xl mx-auto flex items-center justify-between px-8 py-6">
        <div className="flex items-center gap-3">
          <HelpGenieLogo size={40} />
          <div className="flex flex-col">
            <span className="font-bold text-xl text-white tracking-tight">
              Help Genie
            </span>
            <span className="text-xs text-gray-300 -mt-1">
              Your AI Assistant
            </span>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {!user ? (
            <>
              <a
                href="/signin/consumer"
                className="rounded-full px-5 py-2 border-2 border-white text-white bg-white/10 font-semibold hover:bg-white/20 transition"
              >
                Sign In
              </a>
              <a
                href="/signup"
                className="rounded-full px-5 py-2 bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
              >
                Get Started Free
              </a>
            </>
          ) : (
            <>
              <Link
                to="/genie-hub/my-genies"
                className={`rounded-full px-4 py-2 font-medium transition ${
                  isActive('/genie-hub/my-genies')
                    ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                    : 'bg-blue-500/80 text-white hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-500 hover:shadow-lg'
                }`}
              >
                My Genies
              </Link>
              <Button
                onClick={handleSignOut}
                size="sm"
                className="bg-white/20 text-white border border-white/30 hover:bg-white hover:text-gray-900 transition-all duration-200"
              >
                Sign Out
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}